import React, { useState } from 'react';
import { useTheme } from '../context/ThemeContext';
import '../FishFinderBuilder.css';

const ContactPage = () => {
  const { theme } = useTheme();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    reason: '',
    message: '',
    honeypot: '' // Hidden field for spam protection
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Check honeypot field
    if (formData.honeypot) {
      console.log('Spam detected via honeypot');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('');

    try {
      // Using Formspree for form submissions
      const formDataToSend = new FormData();
      formDataToSend.append('name', formData.name);
      formDataToSend.append('email', formData.email);
      formDataToSend.append('reason', formData.reason);
      formDataToSend.append('message', formData.message);

      const response = await fetch('https://formspree.io/f/xyzjbqbk', {
        method: 'POST',
        body: formDataToSend,
        headers: {
          'Accept': 'application/json'
        }
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          reason: '',
          message: '',
          honeypot: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const containerStyle = {
    maxWidth: '800px',
    margin: '0 auto',
    padding: window.innerWidth <= 768 ? '20px 15px' : '40px 20px',
    backgroundColor: theme.isDarkMode ? '#1a1a1a' : '#ffffff',
    color: theme.isDarkMode ? '#ffffff' : '#333333',
    minHeight: '80vh'
  };

  const formStyle = {
    backgroundColor: theme.isDarkMode ? '#2a2a2a' : '#f8f9fa',
    padding: window.innerWidth <= 768 ? '15px' : '30px',
    borderRadius: window.innerWidth <= 768 ? '8px' : '12px',
    border: theme.isDarkMode ? '1px solid #333' : '1px solid #e0e0e0',
    marginTop: window.innerWidth <= 768 ? '0px' : '30px'
  };

  const inputStyle = {
    width: '100%',
    padding: window.innerWidth <= 768 ? '10px 12px' : '12px 16px',
    fontSize: window.innerWidth <= 768 ? '14px' : '16px',
    border: theme.isDarkMode ? '1px solid #444' : '1px solid #ddd',
    borderRadius: window.innerWidth <= 768 ? '6px' : '8px',
    backgroundColor: theme.isDarkMode ? '#333' : '#fff',
    color: theme.isDarkMode ? '#fff' : '#333',
    marginBottom: window.innerWidth <= 768 ? '12px' : '20px',
    boxSizing: 'border-box'
  };

  const buttonStyle = {
    backgroundColor: '#2979ff',
    color: '#ffffff',
    padding: window.innerWidth <= 768 ? '12px 20px' : '14px 28px',
    fontSize: window.innerWidth <= 768 ? '14px' : '16px',
    fontWeight: '600',
    border: 'none',
    borderRadius: window.innerWidth <= 768 ? '6px' : '8px',
    cursor: isSubmitting ? 'not-allowed' : 'pointer',
    opacity: isSubmitting ? 0.7 : 1,
    transition: 'all 0.3s ease'
  };

  return (
    <div style={containerStyle}>
      {/* Header */}
      <div style={{ textAlign: 'center', marginBottom: window.innerWidth <= 768 ? '15px' : '20px' }}>
        <h1 style={{ 
          fontSize: window.innerWidth <= 768 ? '24px' : '32px', 
          fontWeight: '700', 
          marginBottom: window.innerWidth <= 768 ? '10px' : '16px',
          color: theme.isDarkMode ? '#ffffff' : '#333333'
        }}>
          Get in Touch
        </h1>
        <p style={{ 
          fontSize: window.innerWidth <= 768 ? '16px' : '18px', 
          color: theme.isDarkMode ? '#cccccc' : '#666666',
          lineHeight: '1.5',
          maxWidth: '600px',
          margin: '0 auto'
        }}>
          Whether you're a <strong>retailer that wants to be included in the price tools</strong>, a <strong>brand looking to have your products or versions added</strong>, 
          or just have general questions or feedback—I'd love to hear from you.
        </p>
      </div>

      {/* Quick Contact Info */}
      <div style={{
        textAlign: 'center',
        padding: window.innerWidth <= 768 ? '15px' : '20px',
        backgroundColor: theme.isDarkMode ? '#252525' : '#f0f0f0',
        borderRadius: '8px',
        marginBottom: window.innerWidth <= 768 ? '10px' : '30px'
      }}>
        <h3 style={{ 
          fontSize: window.innerWidth <= 768 ? '16px' : '18px', 
          marginBottom: window.innerWidth <= 768 ? '8px' : '12px',
          color: theme.isDarkMode ? '#ffffff' : '#333333'
        }}>
          Prefer Email?
        </h3>
        <p style={{ 
          fontSize: '16px', 
          color: theme.isDarkMode ? '#cccccc' : '#666666'
        }}>
          <a 
            href="mailto:hello@anglerbuilt.com" 
            style={{ 
              color: '#2979ff', 
              textDecoration: 'underline',
              cursor: 'pointer',
              fontSize: window.innerWidth <= 768 ? '16px' : '18px',
              fontWeight: '500'
            }}
          >
            hello@anglerbuilt.com
          </a>
        </p>
      </div>



      {/* Contact Form */}
      <form 
        onSubmit={handleSubmit} 
        style={formStyle}
      >

        
        {/* Honeypot field for spam protection */}
        <div style={{ display: 'none' }}>
          <input
            name="honeypot"
            value={formData.honeypot}
            onChange={handleInputChange}
          />
        </div>

        <h3 style={{ 
          fontSize: window.innerWidth <= 768 ? '16px' : '20px', 
          marginBottom: window.innerWidth <= 768 ? '12px' : '20px',
          color: theme.isDarkMode ? '#ffffff' : '#333333'
        }}>
          Send a Message
        </h3>

        <div style={{ marginBottom: window.innerWidth <= 768 ? '12px' : '20px' }}>
          <label style={{ 
            display: 'block', 
            marginBottom: window.innerWidth <= 768 ? '4px' : '8px', 
            fontWeight: '500',
            fontSize: window.innerWidth <= 768 ? '13px' : '14px',
            color: theme.isDarkMode ? '#ffffff' : '#333333'
          }}>
            Name *
          </label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            required
            style={inputStyle}
            placeholder="Your full name"
          />
        </div>

        <div style={{ marginBottom: window.innerWidth <= 768 ? '12px' : '20px' }}>
          <label style={{ 
            display: 'block', 
            marginBottom: window.innerWidth <= 768 ? '4px' : '8px', 
            fontWeight: '500',
            fontSize: window.innerWidth <= 768 ? '13px' : '14px',
            color: theme.isDarkMode ? '#ffffff' : '#333333'
          }}>
            Email Address *
          </label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            required
            style={inputStyle}
            placeholder="your.email@example.com"
          />
        </div>

        <div style={{ marginBottom: window.innerWidth <= 768 ? '12px' : '20px' }}>
          <label style={{ 
            display: 'block', 
            marginBottom: window.innerWidth <= 768 ? '4px' : '8px', 
            fontWeight: '500',
            fontSize: window.innerWidth <= 768 ? '13px' : '14px',
            color: theme.isDarkMode ? '#ffffff' : '#333333'
          }}>
            What's this about?
          </label>
          <select
            name="reason"
            value={formData.reason}
            onChange={handleInputChange}
            style={inputStyle}
          >
            <option value="">Select a reason (optional)</option>
            <option value="partnership">Business Partnership</option>
            <option value="retailer">Product Listing</option>
            <option value="press">Press Inquiry</option>
            <option value="feedback">Site Feedback</option>
            <option value="technical">Technical Issue</option>
            <option value="other">Other</option>
          </select>
        </div>

        <div style={{ marginBottom: window.innerWidth <= 768 ? '20px' : '30px' }}>
          <label style={{ 
            display: 'block', 
            marginBottom: window.innerWidth <= 768 ? '4px' : '8px', 
            fontWeight: '500',
            fontSize: window.innerWidth <= 768 ? '13px' : '14px',
            color: theme.isDarkMode ? '#ffffff' : '#333333'
          }}>
            Message *
          </label>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleInputChange}
            required
            rows={window.innerWidth <= 768 ? "4" : "6"}
            style={{
              ...inputStyle,
              resize: 'vertical',
              minHeight: window.innerWidth <= 768 ? '80px' : '120px'
            }}
            placeholder="Tell me what's on your mind..."
          />
        </div>

        <button
          type="submit"
          disabled={isSubmitting}
          style={buttonStyle}
          onMouseOver={(e) => {
            if (!isSubmitting) {
              e.target.style.backgroundColor = '#1976d2';
            }
          }}
          onMouseOut={(e) => {
            if (!isSubmitting) {
              e.target.style.backgroundColor = '#2979ff';
            }
          }}
        >
          {isSubmitting ? 'Sending...' : 'Send Message'}
        </button>

        {submitStatus === 'success' && (
          <div style={{
            marginTop: '20px',
            padding: '16px',
            backgroundColor: '#d4edda',
            color: '#155724',
            borderRadius: '8px',
            border: '1px solid #c3e6cb'
          }}>
            <strong>Message sent successfully!</strong> I'll get back to you within 1-2 business days.
          </div>
        )}

        {submitStatus === 'error' && (
          <div style={{
            marginTop: '20px',
            padding: '16px',
            backgroundColor: '#f8d7da',
            color: '#721c24',
            borderRadius: '8px',
            border: '1px solid #f5c6cb'
          }}>
            <strong>Oops!</strong> There was an issue sending your message. Please try the email addresses above instead.
          </div>
        )}
      </form>


    </div>
  );
};

export default ContactPage; 